// src/pages/GoogleAuthCallback.jsx

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axiosInstance from '../axiosInstance';
import { Box, CircularProgress, Typography } from '@mui/material';
import { toast } from 'react-toastify';

const GoogleAuthCallback = () => {
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const ctrl = new AbortController();

    const getToken = async () => {
      try {
        // Importante: withCredentials para enviar la cookie de sesión de allauth
        const response = await axiosInstance.get('/auth/get-token-from-session/', {
          withCredentials: true,
          signal: ctrl.signal,
          params: { t: Date.now() }, // opcional: evita caché
        });

        const token = response?.data?.key || response?.data?.token;
        if (!token) throw new Error('No se pudo obtener el token');

        // Si login() ya persiste el token, no necesitas setItem manual.
        // Elimínalo si login ya lo hace. Si no, déjalo.
        localStorage.setItem('authToken', token);
        localStorage.removeItem('patientToken');
        localStorage.removeItem('guestToken');
        localStorage.removeItem('isGuest');

        await login(token);
        toast.success('¡Inicio de sesión con Google exitoso!');
        navigate('/doctor/dashboard', { replace: true });
      } catch (error) {
        if (error?.name === 'CanceledError' || error?.code === 'ERR_CANCELED') return;
        console.error('Error en el callback de Google:', error);

        if (error?.response?.status === 401) {
          toast.error('Tu sesión con Google ha expirado o no es válida. Intenta nuevamente.');
        } else {
          toast.error('No se pudo completar el inicio de sesión con Google.');
        }

        navigate('/login', {
          replace: true,
          state: { error: 'Error al procesar el inicio de sesión con Google.' }
        });
      }
    };

    getToken();
    return () => ctrl.abort();
  }, [login, navigate]);

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <CircularProgress />
      <Typography sx={{ ml: 2 }}>Finalizando inicio de sesión con Google...</Typography>
    </Box>
  );
};

export default GoogleAuthCallback;
